'use strict';

class AccountDownloadRecipient {
  constructor($scope, $window, originatorService, Notification) {
    this.$scope = $scope;
    this.$window = $window;
    this.originatorService = originatorService;
    this.Notification = Notification;
  }

  $onInit() {
    this.codes = [{
      value: 'json',
      label: 'JSON'
    }, {
      value: 'xml',
      label: 'XML'
    }];
    this.data = {
      code: 'json',
      recipientNumber: 0
    };

    this.$scope.$on('selectedRecipient', (e, val) => {
      if (val) {
        this.data.recipientNumber = val.number;
      } else {
        this.data.recipientNumber = 0;
      }
    });
  }

  downloadRecipient() {
    this.originatorService.validateDownload()
      .then(() => {
        this.originatorService.downloadRecipientData(this.data.code, this.data.recipientNumber)
          .then(() => {
          });
      });
  }
}

AccountDownloadRecipient.$inject = ['$scope', '$window', 'originatorService', 'Notification'];

const accountDownload = {
  controller: AccountDownloadRecipient,
  template: `
    <h2>Last ned data om mottager</h2>
    <h3>Dataene kommer i form av en fil i JSON- eller XML-format</h3>

    <fieldset>
      <div>
        <label for="code">Velg format:</label>
        <select ng-model="$ctrl.data.code" ng-options="code.value as code.label for code in $ctrl.codes" id="code" required></select>
      </div>
      <recipient-picker number="$ctrl.data.recipientNumber" allownew="'n'"></recipient-picker>
    </fieldset>

    <a role="button" class="button secondary" href="#/konto">Avbryt</a>
    <button ng-click="$ctrl.downloadRecipient()" class="button alert">Last ned data om mottager</button>
  `
};

angular
  .module('SendRegning')
  .component('accountDownloadRecipient', accountDownload)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/last-ned-mottager', {
        title: 'Last ned mottagerdata',
        template: '<account-download-recipient />',
        secure: true
      });
  });
